import {NameValueMap} from '../../smart-shared/classes/KeyValueMap';

export const SMART_FORM_DEFS: NameValueMap<any> = {
  layoutLabelInput : {
  }
};
